module.exports = __webpack_public_path__ + "img/full5-min.8287d19c.png";